// Bitte InputNotifier.js verwenden.
function EingabeFeld(eingabe) {
	this.eingabe = eingabe;
	this.bemerktAenderungBeimTippen = false;
	this.timer = undefined;
	this.aufgabe = undefined;
	this.$ = $(eingabe);

	$(eingabe).on('focus', this._focus.bind(this));
	$(eingabe).on('blur', this._blur.bind(this));
}

EingabeFeld.prototype._focus = function () {
	if (this.bemerktAenderungBeimTippen) {
		this.timer = setInterval(() => this._checkTimer(), 200);
	}
};

EingabeFeld.prototype._blur = function () {
	clearInterval(this.timer);
	if ($(this.eingabe).val() !== '') {
		this.bemerktAenderungBeimTippen = true;
	}
	if (this.wertGeaendert() && this.aufgabe) {
		this.aufgabe();
	}
};

EingabeFeld.prototype._checkTimer = function () {
	if (this.wertGeaendert() !== '' && this.aufgabe) {
		this.aufgabe();
	}
};

EingabeFeld.prototype.attach = function (aufgabe) {
	this.aufgabe = aufgabe;
};

EingabeFeld.prototype.wertGeaendert = function () {
	if (!this.bemerktAenderungBeimTippen) {
		return false;
	}
	const wert = $(this.eingabe).val();
	return this.letzterWert !== wert;
};

EingabeFeld.prototype.val = function (wert) {
	if (wert === undefined) {
		return $(this.eingabe).val();
	}
	return $(this.eingabe).val(wert);
};

EingabeFeld.prototype.valIfChanged = function (wert) {
	if (wert !== undefined) {
		if (wert === null) {
			wert = '';
		}
		const ret = $(this.eingabe).valEx !== undefined ? $(this.eingabe).valEx(wert) : $(this.eingabe).val(wert);
		if (this.bemerktAenderungBeimTippen && this.letzterWert !== wert) {
			this.letzterWert = wert;
			if (this.aufgabe) {
				this.aufgabe();
			}
			const self = this;
			if ($(self.eingabe).valid !== undefined) {
				window.setTimeout(function () {
					$(self.eingabe).valid();
				}, 100);
			}
		} else {
			this.letzterWert = wert;
		}
		return ret;
	}
	if (!this.bemerktAenderungBeimTippen) {
		return '';
	}
	wert = $(this.eingabe).val();
	this.letzterWert = wert;
	return wert;
};
